import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
} from '../../actions/discovery/explainScenario';

// Reports are cached per scenario_id so flipping between saved scenarios
// keeps every already-fetched report available without refetching.
const initialState = {
  reports: {},
  loadingId: null,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return {
        ...state,
        loadingId: action.payload?.scenarioId || null,
        error: null,
      };
    case res: {
      const id = action.payload?.scenario_id;
      const report = action.payload?.report;
      if (!id || !report) return { ...state, loadingId: null };
      return {
        ...state,
        loadingId: null,
        reports: { ...state.reports, [id]: report },
      };
    }
    case fail:
      return { ...state, loadingId: null, error: action.payload };
    case clr:
      return { ...initialState };
    default:
      return state;
  }
};
